import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  variant?: 'square' | 'round';
}

const CheckboxWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 24px;
  width: 24px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div<{ checked: boolean; variant?: 'square' | 'round' }>`
  width: 16px;
  height: 16px;
  background: ${({ checked }) => (checked ? colors.accentPrimary : colors.accentQuaternary)};
  border-radius: ${({ variant }) => (variant === 'round' ? '50%' : '3px')};
  transition: all 150ms;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ checked }) => (checked ? colors.accentPrimary : colors.accentQuaternary3)};

  svg {
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
  }
`;

const CheckboxIcon = () => (
  <svg width="8" height="8" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, className, variant = 'square' }) => {
  return (
    <CheckboxWrapper className={className} onClick={() => onChange(!checked)}>
      <HiddenCheckbox checked={checked} onChange={() => onChange(!checked)} />
      <StyledCheckbox checked={checked} variant={variant}>
        <CheckboxIcon />
      </StyledCheckbox>
    </CheckboxWrapper>
  );
};
